import Phaser from "phaser";

export default class WinModal extends Phaser.GameObjects.Container {
    constructor(scene, x, y, scale, winStreak, pfp, gameData, playerBonezMatchData){
        super(scene, x, y)
        this.scene = scene;
        this.winStreak = winStreak;
        this.gameData = gameData;
        this.playerBonezMatchData = playerBonezMatchData;

        const graphics = scene.add.graphics();
        
        // Obtain the screen width and height
        const screenWidth = scene.sys.game.config.width;
        const screenHeight = scene.sys.game.config.height;
        
        // Calculate the center of the screen
        const centerX = screenWidth / 2;
        const centerY = screenHeight / 2;
        
        // Predefined rectangle parameters
        const RECTANGLE_WIDTH = x * 0.68;
        const RECTANGLE_HEIGHT = y * 1.6;
        const ROUNDED_CORNER_RADIUS = 100; 

        const rectX = centerX - (RECTANGLE_WIDTH / 2);
        const rectY = centerY - (RECTANGLE_HEIGHT / 2);

        
        const WINNERTEXT_STYLE = {
            fontSize: 200*scale + "px",
            fontFamily: "TruculentaBold",
            fill: "#BD00FF",
            align: "center"
        };
        
        const USERNAME_STYLE = {
            fontSize: 150*scale + "px",
            fontFamily: "TruculentaBold",
            fill: "#00D1FF",
            align: "center"
        };
        
        const XP_STYLE = {
            fontSize: 80*scale + "px",
            fontFamily: "TruculentaBold",
            fill: "#FFC350",
            align: "center"
        };
        
        const STREAK_STYLE = {
            fontSize: 100*scale + "px",
            fontFamily: "TruculentaBold",
            fill: "#FF7A00",
            align: "center"
        };

        const BUTTON_STYLE = {
            fontSize: 82*scale + "px",
            fontFamily: "TruculentaBold",
            fill: "#000000",
            align: "center"
        };

        let potAmount = this.gameData.matchInfo.potAmount;
        const wagerType = this.gameData.matchInfo.wagerType;

        // Getting biggest pot won value
        let biggestPotWonChipz = this.playerBonezMatchData.biggestPotWonChipz;
        let biggestPotWonBones = this.playerBonezMatchData.biggestPotWonBones;

        function determineAudioForChipz(pot, biggestPotWon) {
            switch (true) {
                case (pot > biggestPotWon):
                    return "big_win_sound";
                case (pot <= 1000000):
                    return "small_win_sound";
                case (pot > 1000000 && pot < 100000000):
                    return "medium_win_sound";
                default:
                    return null;
            }
        }

        function determineAudioForBones(pot, biggestPotWon) {
            switch (true) {
                case (pot > biggestPotWon):
                    return "big_win_sound";
                case (pot <= 1000):
                    return "small_win_sound";
                case (pot > 1000):
                    return "medium_win_sound";
                default:
                    return null;
            }
        }

        let audioToPlay;

        if (wagerType === "zoom") {
            audioToPlay = determineAudioForChipz(potAmount, biggestPotWonChipz);
        } else if (wagerType === "bonez") {
            audioToPlay = determineAudioForBones(potAmount, biggestPotWonBones);
        }

        let game_end_sound = scene.sound.add(audioToPlay);
        this.LOCAL_STORAGE_SOUND_VOLUME = 'soundVolume';

        // fetching values from local storage or use default values
        this.soundVolumeFromStorage = localStorage.getItem(this.LOCAL_STORAGE_SOUND_VOLUME);
        this.soundVolume = this.soundVolumeFromStorage !== null ? +this.soundVolumeFromStorage / 100 : 12.5 / 100;

        this.checkForVolumeChange = () => {
            let newSoundVolume = localStorage.getItem(this.LOCAL_STORAGE_SOUND_VOLUME);
            newSoundVolume = newSoundVolume !== null ? +newSoundVolume / 100 : 12.5 / 100;

            if (this.soundVolume !== newSoundVolume) {
                this.soundVolume = newSoundVolume;
                game_end_sound.setVolume(this.soundVolume);
            }
        }
        
        this.scene.time.addEvent({
            delay: 500,
            callback: this.checkForVolumeChange,
            loop: true
        });

        if (audioToPlay) {
            // declare sounds first
            game_end_sound.play();
            game_end_sound.setVolume(this.soundVolume);
        }

        // Stroke style
        const STROKE_COLOR = 0x00D1FF;  // Change this to the color you want
        const STROKE_THICKNESS = scale * 8;   // Change this to adjust the thickness
        graphics.lineStyle(STROKE_THICKNESS, STROKE_COLOR);

        // Fill color to black
        graphics.fillStyle(0x161B2F, 1);

        // Draw a filled rectangle with predefined parameters
        graphics.fillRoundedRect(rectX, rectY, RECTANGLE_WIDTH, RECTANGLE_HEIGHT, ROUNDED_CORNER_RADIUS);
        
        // Draw the stroke around the rectangle
        graphics.strokeRoundedRect(rectX, rectY, RECTANGLE_WIDTH, RECTANGLE_HEIGHT, ROUNDED_CORNER_RADIUS);

        //Add "Winner" Text
        const winnerText = scene.add.text(centerX, rectY + (scale * 150), 'WINNER!' , WINNERTEXT_STYLE);
        winnerText.setOrigin(0.5, 0.5); // Center the text within the rectangle
        winnerText.setDepth(101); // Set the depth of the text to be above the rectangle


        const maskGraphics = this.scene.add.graphics();
        maskGraphics.fillStyle(0xffffff); // Set the mask color (white)
        maskGraphics.fillCircle(rectX + (scale * 168), rectY + (scale * 150), (scale * 80)); // Define the circle's position and radius
        const mask = new Phaser.Display.Masks.GeometryMask(this, maskGraphics);
        this.pfpImage = this.scene.add.image(rectX + (scale * 170) , rectY + (scale * 150), pfp).setScale(1.7 * scale).setDepth(101).setMask(mask);

        const winnerUsername = scene.add.text(centerX, rectY + (scale * 300), this.gameData.player.username, USERNAME_STYLE);
        winnerUsername.setOrigin(0.5, 0.5);
        winnerUsername.setDepth(101);

        //xp image
        const xpImage = scene.add.image(centerX - (scale * 100), centerY + (scale * 420), 'xp_icon').setScale(0.15 * scale); // adjust the y-coordinate as necessary
        xpImage.setOrigin(0.5, 0.5); // Center the image
        xpImage.setDepth(101);
        //xp text
        const xpText = scene.add.text(centerX + (scale * 20), centerY + (scale * 420), `+ 12`, XP_STYLE);
        xpText.setOrigin(0.5, 0.5);
        xpText.setDepth(101);
        
        // Create the win streak value text
        const streakValueText = scene.add.text(centerX - (scale * 270), centerY + (scale * 600), `${this.winStreak}`, STREAK_STYLE);
        streakValueText.setOrigin(1, 0.5); // Adjust the origin to make it right aligned
        streakValueText.setDepth(101);
        // Create the fire image
        const fireImage = scene.add.image(centerX - (scale * 190), centerY + (scale * 600), 'fire_icon').setScale(3 * scale);
        fireImage.setOrigin(0.5, 0.5); 
        fireImage.setDepth(101);
        // Create the text with space reserved for the win streak value and the fire image
        const winStreakText = scene.add.text(centerX - (scale * 130), centerY + (scale * 600), `WIN STREAK!`, STREAK_STYLE);
        winStreakText.setOrigin(0, 0.5);  // Adjust the origin for left align
        winStreakText.setDepth(101);

        // Set the fire image
        const buttonImage = scene.add.image(centerX, centerY + (scale * 850), 'GreenButton').setScale(1.7 * scale);
        buttonImage.setOrigin(0.5, 0.5); 
        buttonImage.setDepth(101);

        const buttonText = scene.add.text(centerX, centerY + (scale * 850), `Return to Lobby`, BUTTON_STYLE);
        buttonText.setOrigin(0.5, 0.5);
        buttonText.setDepth(101);

        // Set the button image as interactive
        buttonImage.setInteractive();

        // Add an event listener to the button image for the pointer down event
        buttonImage.on('pointerdown', function() {
            window.location.href = "/bonez";
        });

        return graphics;
    }
}